module.exports = __webpack_public_path__ + "img/Avatar-Femme.c1195a4d.png";